import { useAppIntl } from 'src/i18n'
import { BaseLayout } from 'src/layouts'
import React, { useState } from 'react'

import { Table } from './components/Table'
import { WEBSITE } from 'src/consts'
import styles from './styles.module.scss'

export const NFTTable = () => {
  const intl = useAppIntl()
  const [filterVisibility, setFilterVisibility] = useState(false)

  return (
    <BaseLayout
      scrollInContent
      seo={{
        title: intl.t('nftTable.seo.title'),
        description: intl.t('nftTable.seo.description'),
        canonical: `${WEBSITE}/nft/table`,
      }}
      filterToggle={setFilterVisibility}
    >
      <Table
        filterVisibility={filterVisibility}
        setFilterVisibility={setFilterVisibility}
      />
      <h2 className={styles.seoTags}>Browse the Top NFTs By Sales Volume</h2>
      <h2 className={styles.seoTags}>
        Discover NFT Sales Volume and Estimated Market Cap
      </h2>
    </BaseLayout>
  )
}
